import type { AvailableForm, FormCategoryType } from '@payaca/types/formTypes';
import { FormOptionGroups } from '@payaca/types/formTypes';

export const sortedAvailableFormOptions = (
  availableForms: AvailableForm[],
  excludeArchived = true
) => {
  return (availableForms || [])
    .filter((x) => !excludeArchived || !x.archivedAt)
    .map(
      ({
        label,
        value,
        category,
      }: {
        label: string;
        value: number;
        category: FormCategoryType;
      }) => {
        const optionGroup = FormOptionGroups.find(
          (optionGroup) => optionGroup.name === category
        );
        return {
          label,
          value,
          optionGroupId: optionGroup ? optionGroup.id : 1,
        };
      }
    )
    .sort((a, b) => (a.optionGroupId < b.optionGroupId ? -1 : 1));
};

const radioAnswerMap: any = {
  yes: 'Yes',
  no: 'No',
  na: 'N/A',
  pass: 'Pass',
  fail: 'Fail',
};

const gcNumberFormatter = (answer: string) => {
  const sect1 = answer.slice(0, 2);
  const sect2 = answer.slice(2, 5);
  const sect3 = answer.slice(5);
  return `${sect1}-${sect2}-${sect3}`;
};

export const getValueFromPath = (data: any, keyPath = 'empty.string') =>
  keyPath.split('.').reduce((acc, path) => {
    if (!acc) return acc;
    acc = acc[path] || '';
    return acc;
  }, data);

export const formatAnswer = (
  data: any,
  keyPath?: string,
  historicKeyPath?: string
) => {
  let answer = data;

  if (keyPath) {
    // historicKeyPath gives us a way to preserve backwards compatability on form template updates
    answer =
      getValueFromPath(data, keyPath) ||
      getValueFromPath(data, historicKeyPath);

    if (keyPath === 'gc_number') {
      return gcNumberFormatter(answer);
    }
  }
  return radioAnswerMap[answer] || answer;
};

export const parseAddress = (address: string) => {
  if (address) {
    const addressArr = address.split(', ');
    const firstLineAddress = addressArr.shift();
    const secondLineAddress = addressArr.join(', ');
    return {
      firstLineAddress,
      secondLineAddress,
    };
  }

  return {
    firstLineAddress: '',
    secondLineAddress: '',
  };
};
